export default "__VITE_ASSET__JzF3KMfc__"